import React, { useEffect, useRef } from 'react';
import './Section.css';

const Section = ({ id, title, subtitle, children, className = '' }) => {
  const sectionRef = useRef(null);
  const sectionCodes = {
    about: '01',
    projects: '02',
    experience: '03',
    contact: '04'
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id={id} className={`section ${className}`} ref={sectionRef}>
      <div className="section-container">
        {(title || subtitle) && (
          <div className="section-header">
            <span className="section-code">{`${sectionCodes[id] || '00'} / ${id}`}</span>
            {title && <h2 className="section-title">{title}</h2>}
            {subtitle && <p className="section-subtitle">{subtitle}</p>}
          </div>
        )}
        <div className="section-content">
          {children}
        </div>
      </div>
    </section>
  );
};

export default Section;
